import { create } from 'zustand';

import { ComboboxModelModel } from '@app-evolution-cms/element-ui';

type TState = {
  starmanIcons: ComboboxModelModel;
};

type TActions = {
  setStarmanIcons: (starmanIcons: ComboboxModelModel) => void;
};

const initialState: TState = {
  starmanIcons: [],
};

const useStarmanIconsState = create<TState & TActions>()((set) => ({
  ...initialState,
  setStarmanIcons: (starmanIcons) => set({ starmanIcons }),
}));

export { useStarmanIconsState };
